import * as React from 'react';

export const SafeAreaProvider = (props: { children: React.ReactNode }) => {
  return (
    <>
      {props.children}
    </> 
  )
}
